export const PAGINATION_WRAPPER_ID = 'pagination-wrapper';

export const PRODUCT_CARD_GRID_ITEM_ID = 'PRODUCT_CARD_GRID_ITEM';
